import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e34b32e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-overflow-auto hiddenBorderFirstChild" }
const _hoisted_2 = { class: "tw-px-[20px] sm:tw-px-[40px]" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import { computed, ref, watch } from "vue";
import Modal from "@/components/common/modal.vue";
import TableActionSwitchTab from "./tableActionSwitchTab.vue";
import { ISwitchTabs } from "@/interfaces/assessments/ISwitchTabs";
import {
  classModal,
  idTabActionTableRecommendation,
  styleClassContain,
} from "@/utils/constants";
import CreateActionNewTab from "./createActionNewTab.vue";
import AddNewActionSuggestedTab from "./addNewActionSuggestedTab.vue";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";


export default /*#__PURE__*/_defineComponent({
  __name: 'addNewActionModal',
  props: {
  show: {
    type: Boolean,
    required: true,
  },
},
  emits: ["update:show", "update:data"],
  setup(__props, { emit }) {

const props = __props;

const activeTab = ref(idTabActionTableRecommendation.overview);

const dataAction = ref({});

// add tab component to field component
const tabs = computed<ISwitchTabs[]>(() => {
  return [
    {
      title: getComponentUiText(
        "app-assess-recommendations-section-action-create-action-title-new-1",
      ),
      id: idTabActionTableRecommendation.overview,
      component: CreateActionNewTab,
      props: {
        data: dataAction.value,
        show: showRef,
      },
    },
    {
      title: getComponentUiText(
        "app-component-suggestion-button-title-suggested-1",
      ),
      id: idTabActionTableRecommendation.stepsToSolve,
      component: AddNewActionSuggestedTab,
    },
  ];
});



const showRef = ref(props.show);
const isDirty = ref(false);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);



const handleUseAction = (data: any) => {
  activeTab.value = idTabActionTableRecommendation.overview;
  dataAction.value = data?.addedActions[0];
};

const onCloseModal = () => {
  if (isDirty.value) {
    return;
  }
  handleCloseModal();
};
const handleCloseModal = () => {
  eventEmitter.emit(EmitterEvents.REMOVE_ITEM_SELECTED_ROW, []);
  showRef.value = false;
  emit("update:show", showRef.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    visible: showRef.value,
    "max-width": 65,
    "style-class": _unref(classModal),
    "style-class-contain": _unref(styleClassContain),
    "class-name": 'edit-modal-action !tw-translate-y-[0]',
    onClose: onCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        class: _normalizeClass(`modal-header`),
        title: 
        _unref(getComponentUiText)(
          'app-assess-recommendations-section-action-create-action-option-1',
        )
      ,
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TableActionSwitchTab, {
            tabs: tabs.value,
            "default-tab": 0,
            "id-selected-tab": activeTab.value,
            "item-class": "tw-px-[25px] tw-pt-[24px] tw-pb-[21px] !tw-text-[16px]",
            "onUpdate:tab": _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = $event))
          }, {
            rightHeader: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["tabs", "id-selected-tab"])
        ]),
        (_openBlock(), _createBlock(_resolveDynamicComponent(tabs.value.filter((item) => item?.id === activeTab.value)[0].component), _mergeProps({ data: {} }, tabs.value.filter((item) => item?.id === activeTab.value)[0].props, {
          "onUpdate:show": handleCloseModal,
          "onUpdate:use": handleUseAction
        }), null, 16))
      ])
    ]),
    _: 1
  }, 8, ["visible", "style-class", "style-class-contain"]))
}
}

})